import styled from 'styled-components';

export const StyledInputContainer = styled.div`
    display: flex;
    color: white;
    font-size: 16px;
    line-height: 18px;
    // width: 100%;
`

export const StyledInput = styled.input`
    color: white;
    background-color: #659E62;
    border-radius: 15px;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 12px;
    line-height: 10px;
    height: 25px;
    border: none;
`